<template>
    <row>
        <column cols="full">
            <divider class="mb-2" color="accent" width="56"></divider>
            <div
                class="w-full text-left text-white mb-16 poppins-bold tracking-normal leading-highest xs:text-3xl sm:text-5xl">
                fitt
                user groups
            </div>
            <row align="stretch" class="uppercase -mx-2" justify="start">
                <column :key="index"
                        class="mb-12 px-2 text-center"
                        v-for="(group, index) in groups"
                        align="center"
                        xs="1/2"
                        sm="1/3"
                        md="1/4"
                        lg="1/6"
                        xl="1/8"
                >
<!--                    :md="'1/'+groups.length"-->
                    <btn class="mb-5" color="white" fab size="71">
                        <icon :icon="group.icon" color="primary"></icon>
                    </btn>
                    <div class="text-white text-center poppins-bold tracking-wide leading-tight"
                         v-html="group.text"
                    ></div>
                </column>
            </row>
        </column>
    </row>
</template>

<script>
    export default {
        name: "UserGroups",
        props: {},
        components: {
            // row: () => import('@/components/display/Row.vue'),
            // column: () => import('@/components/display/Col.vue'),
            btn: () => import('@/components/Btn.vue'),
            icon: () => import('@/components/display/Icon.vue'),
            divider: () => import('@/components/Divider.vue')
        },
        data: () => ({
            groups: [
                {icon: 'domain', text: 'Corporate<br>Organizations'},
                {icon: 'account-multiple', text: 'Leaders and<br>professionals'},
                {icon: 'message-reply-text', text: 'Professional<br>Service firms'},
                {icon: 'school', text: 'Learners and<br>graduates'},
                {icon: 'star-circle', text: 'Professional<br>talent<br>practitioners'},
                {icon: 'book-open-variant', text: 'Corporate<br>education<br>providers'},
                {icon: 'clipboard-account', text: 'Recruiters'},
                {icon: 'bank', text: 'Finance<br>providers'}
            ]
        }),
        computed: {
            mobile() {
                return outerWidth <= parseInt(this.$theme.screens.sm.min.replace('px', ''));
            }
        }
    }
</script>

<style scoped>

</style>